import styled from "styled-components";

export const Container = styled.div`
  width: 640px;
  height: 100%;
  background-color: #161a1d;
  transition: width 0.3s ease;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 100;
  position: relative;
  left: 80px;

  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  border-radius: 16px;
`;

export const MainContent = styled.div`
  padding: 10px 20px 15px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex-grow: 1;
  overflow-y: scroll;
  &::after {
    content: "";
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
  }
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #2a2d40;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #4e5574;
    border-radius: 4px;
  }

  scrollbar-color: #4e5574 #2a2d40;
  scrollbar-width: thin;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 29px;
`;

export const SortContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

export const SortText = styled.span`
  font-size: 13px;
  color: #ffffff;
`;

export const ImageWrapper = styled.div<{disabled?: boolean}>`
  width: 24px;
  height: 24px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const SortByText = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  margin-right: 5px;
`;

export const TitleCard = styled.h2<{color?: string}>`
  color: ${(props) => (props.color ? props.color : "#71c6fa")};
  font-size: 30px;
  font-weight: 400;
`;

export const LoaderSkeleton = styled.div<{width?: string; height?: string}>`
  width: ${(props) => props.width || "100px"};
  height: ${(props) => props.height || "100px"};
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;

  background: linear-gradient(90deg, #4e5574, rgb(41, 45, 66), #4e5574);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;

  @keyframes skeleton-loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
